<template>
    <div class="px-4 py-8 sm:px-10">
        <NftLogo :nft="nft"></NftLogo>
        <div v-if="existingUser">
            <h2 class="text-lg leading-6 font-medium text-gray-900">
                {{ translate('order.body:headline', {name: user.name}) }}!
            </h2>
        </div>
        <div>
            <p class="mt-5 mb-5 whitespace-pre-wrap" v-html="translate('order.body:content', {billingProvider})"></p>
            <p class="text-right">
                <a :href="buyUrl" class="inline-flex items-end justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700">{{translate('order.body:buttonLabel')}}</a>
            </p>
        </div>
    </div>
</template>
<script>

import NftLogo from "./../Common/NftLogo";
import {computed, ref} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";
import translate from "../../../lang";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/24/outline'

export default {
    components: {
        NftLogo,
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckIcon
    },
    props: {
        nft: Object,
        buyUrl: String,
        existingUser: Boolean,
        billingProvider: String,
    },
    setup(props) {
        const user = computed(() => usePage().props.value.auth.user)
        const billingProvider = computed(() => usePage().props.value.billingProvider);
        const open = ref(true);
        return {
            open,
            billingProvider,
            user,
            translate: props.nft ? translate('upload-' + usePage().props.value.metaDataType.type) : translate('auth')
        };
    }
};
</script>
